import { useRouter } from "next/router";
import { connectCurrentRefinements } from "react-instantsearch-dom";
import { twMerge } from "tailwind-merge";

const ClearAllFilters = connectCurrentRefinements(({ items, refine }) => {
  const router = useRouter();

  return (
    <div className="w-full text-right">
      <button
        type="button"
        className={twMerge(
          "bg-red-50 font-aeonik text-xs font-medium uppercase tracking-wider text-red-700",
          "hover:bg-red-500 hover:text-white",
          "w-full rounded-xl border border-red-900/20 p-4",
          "lg:w-auto lg:rounded-full lg:border-transparent lg:px-3 lg:py-1",
        )}
        disabled={items.length === 0}
        onClick={() => {
          if (router.query.searchState) {
            router.replace("/", "/");
          }

          refine(items);
        }}
      >
        Remover filtros
      </button>
    </div>
  );
});

export default ClearAllFilters;
